import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAboutData } from "../../utils/home-util";

export const getAboutDatareq = createAsyncThunk(
  "getAboutDatareq",
  async (res) => {
    const responce = await getAboutData(res);
    return responce.data;
  }
);

const aboutSlice = createSlice({
  name: "about",
  initialState: {
    aboutPageData: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAboutDatareq.fulfilled, (state, action) => {
      state.loading = false;
      state.aboutPageData = action.payload;
      state.error = null;
    });
    builder.addCase(getAboutDatareq.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getAboutDatareq.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {} = aboutSlice.actions;
export default aboutSlice.reducer;
